import Picture from "@/assets/images/mail_box.svg";
import Header from "@/components/header";
import {
  ActionIcon,
  Anchor,
  Button,
  Center,
  Container,
  CopyButton,
  Image,
  rem,
  Stack,
  Table,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";

import CustomDrawer from "@/components/drawer";
import { useUserSignupByReferralCode } from "@/services/referralCode/hooks/useUserSignupByReferralCode";
import { dateUtilities } from "@/utilities/helper/dateUtilities/dateUtilities";
import { useDisclosure } from "@mantine/hooks";
import { IconAddressBookOff, IconCheck, IconCopy } from "@tabler/icons-react";
import useGetMerchant from "../hooks/useGetMerchant";

function ReferralCode() {
  const { data } = useGetMerchant();
  const { data: users } = useUserSignupByReferralCode();
  const [opened, { open, close }] = useDisclosure(false);

  const rows = users?.map((element) => (
    <Table.Tr key={element.phoneNumber}>
      <Table.Td>
        <Text size="xs"> {element.phoneNumber} </Text>
      </Table.Td>
      <Table.Td>
        <Text size="xs">
          {dateUtilities.convertToPersianDateTime(element.creationTime || "")}
        </Text>
      </Table.Td>
    </Table.Tr>
  ));
  return (
    <>
      <Header title="ارسال دعوت نامه" showBack route="/dashboard/profile" />
      <Container w="100%" size="md" >
        <Title order={4}> ارسال دعوت نامه </Title>
        <Stack mih="calc(100svh - 200px)">
          <Stack align="center" flex={1} justify="space-evenly">
            <Image src={Picture} w={150} my="sm" />
            <Text span ta="justify">
              <Text fw="800" c="blue" span pl="xs">
                5
              </Text>
              نفر از دوستان خود را به پدیکس دعوت کنید و به ازای هر ثبت نام موفق
              <Text fw="800" c="blue" span px="5">
                100 هزار ریال
              </Text>{" "}
              <Text span>اعتبار پیامکی دریافت نمایید.</Text>
            </Text>
            <Stack mt="xl" flex={0.8} justify="space-evenly" w="100%">
              <CopyButton value={data?.referralCode || ""} timeout={2000}>
                {({ copied, copy }) => (
                  <Button
                    variant="outline"
                    onClick={copy}
                    mx="auto"
                    size="lg"
                    w="150"
                    styles={{
                      root: {
                        borderStyle: "dashed",
                        borderWidth: 2,
                      },
                    }}
                    leftSection={
                      <Tooltip
                        opened={copied}
                        label={copied ? "کپی شد" : ""}
                        withArrow
                        position="right"
                      >
                        <ActionIcon
                          color={copied ? "teal" : "gray"}
                          variant="subtle"
                        >
                          {copied ? (
                            <IconCheck style={{ width: rem(16) }} />
                          ) : (
                            <IconCopy style={{ width: rem(16) }} />
                          )}
                        </ActionIcon>
                      </Tooltip>
                    }
                  >
                    <Text size="xl">{data?.referralCode}</Text>
                  </Button>
                )}
              </CopyButton>
              <Center>
                <Anchor underline="always" onClick={open}>
                  {" "}
                  مشاهده افراد دعوت شده{" "}
                </Anchor>
              </Center>
            </Stack>
          </Stack>
          <CustomDrawer
            opened={opened}
            close={close}
            onClose={close}
            position="bottom"
          >
            {users && users?.length > 0 ? (
              <>
                <Text>افراد دعوت شده توسط شما</Text>
                <Table
                  striped
                  highlightOnHover
                  withTableBorder
                  withColumnBorders
                  mt="md"
                >
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>
                        <Text size="xs">شماره تماس</Text>
                      </Table.Th>
                      <Table.Th>
                        <Text size="xs">تاریخ عضویت</Text>{" "}
                      </Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>{rows}</Table.Tbody>
                </Table>
              </>
            ) : (
              <Stack justify="center" align="center">
                <IconAddressBookOff
                  color="var(--mantine-color-gray-4)"
                  size={70}
                />
                <Stack>
                  <Text ta="center" c="gray.6" px="lg">
                    در حال حاضر کاربری با کد معرف شما ثبت نامی انجام نداده است.
                  </Text>
                </Stack>
              </Stack>
            )}
          </CustomDrawer>
        </Stack>
      </Container>

    </>
  );
}

export default ReferralCode;
